import { Injectable } from '@angular/core';
import { UserPreferencesService } from 'app/shared/services-api-central/user-preferences/user-preferences.service';
export type DateFormatT = 'd' | 'dm' | 'dmy' | 'm' | 'my' | 'y' | 'dt' | 'dts' | 'dmt' | 'dmts' | 'dmyt' | 'dmyts' | 't' | 'ts';
export type DatePatternT = 'dd MMM yyyy' | 'dd.MM.yy' | 'dd/MM/yy' | 'dd-MM-yy' | 'MMM dd yyyy' | 'MM.dd.yy' | 'MM/dd/yy' | 'MM-dd-yy' | 'yyyy.MM.dd';
export type TimePatternT = 'HH:mm' | 'hh:mm' | 'hh.mm';

@Injectable({
  providedIn: 'root'
})
export class DateTimeFormatService {

  public dateTimeFormats = {
    ['HH:mm']: {
      ['dd MMM yyyy']: {
        ['d']: 'DD',
        ['dm']: 'dd MMM',
        ['dmy']: 'dd MMM yyyy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD HH:mm',
        ['dts']: 'DD HH:mm:ss',
        ['dmt']: 'dd MMM HH:mm',
        ['dmts']: 'dd MMM HH:mm:ss',
        ['dmyt']: 'dd MMM yyyy HH:mm',
        ['dmyts']: 'dd MMM yyyy HH:mm:ss',
        ['t']: 'HH:mm',
        ['ts']: 'HH:mm:ss',
      },
      ['dd.MM.yy']: {
        ['d']: 'DD',
        ['dm']: 'dd.MM',
        ['dmy']: 'dd.MM.yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD HH:mm',
        ['dts']: 'DD HH:mm:ss',
        ['dmt']: 'dd.MM HH:mm',
        ['dmts']: 'dd.MM HH:mm:ss',
        ['dmyt']: 'dd.MM.yy HH:mm',
        ['dmyts']: 'dd.MM.yy HH:mm:ss',
        ['t']: 'HH:mm',
        ['ts']: 'HH:mm:ss',
      },
      ['dd/MM/yy']: {
        ['d']: 'DD',
        ['dm']: 'dd/MM',
        ['dmy']: 'dd/MM/yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD HH:mm',
        ['dts']: 'DD HH:mm:ss',
        ['dmt']: 'dd/MM HH:mm',
        ['dmts']: 'dd/MM HH:mm:ss',
        ['dmyt']: 'dd/MM/yy HH:mm',
        ['dmyts']: 'dd/MM/yy HH:mm:ss',
        ['t']: 'HH:mm',
        ['ts']: 'HH:mm:ss',
      },
      ['dd-MM-yy']: {
        ['d']: 'DD',
        ['dm']: 'dd-MM',
        ['dmy']: 'dd-MM-yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD HH:mm',
        ['dts']: 'DD HH:mm:ss',
        ['dmt']: 'dd-MM HH:mm',
        ['dmts']: 'dd-MM HH:mm:ss',
        ['dmyt']: 'dd-MM-yy HH:mm',
        ['dmyts']: 'dd-MM-yy HH:mm:ss',
        ['t']: 'HH:mm',
        ['ts']: 'HH:mm:ss',
      },
      ['MMM dd yyyy']: {
        ['d']: 'DD',
        ['dm']: 'MMM dd',
        ['dmy']: 'MMM dd yyyy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD HH:mm',
        ['dts']: 'DD HH:mm:ss',
        ['dmt']: 'MMM dd HH:mm',
        ['dmts']: 'MMM dd HH:mm:ss',
        ['dmyt']: 'MMM dd yyyy HH:mm',
        ['dmyts']: 'MMM dd yyyy HH:mm:ss',
        ['t']: 'HH:mm',
        ['ts']: 'HH:mm:ss',
      },
      ['MM.dd.yy']: {
        ['d']: 'DD',
        ['dm']: 'MM.dd',
        ['dmy']: 'MM.dd.yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD HH:mm',
        ['dts']: 'DD HH:mm:ss',
        ['dmt']: 'MM.dd HH:mm',
        ['dmts']: 'MM.dd HH:mm:ss',
        ['dmyt']: 'MM.dd.yy HH:mm',
        ['dmyts']: 'MM.dd.yy HH:mm:ss',
        ['t']: 'HH:mm',
        ['ts']: 'HH:mm:ss',
      },
      ['yyyy.MM.dd']: {
          ['d']: 'DD',
          ['dm']: 'yyyy.MM',
          ['dmy']: 'yyyy.MM.dd',
          ['m']: 'MMM',
          ['my']: 'MMM yyyy',
          ['y']: 'yyyy',
          ['dt']: 'DD hh.mm a',
          ['dts']: 'DD hh.mm.ss a',
          ['dmt']: 'yyyy.MM hh.mm a',
          ['dmts']: 'yyyy.MM hh.mm.ss a',
          ['dmyt']: 'yyyy.MM.dd hh.mm a',
          ['dmyts']: 'yyyy.MM.dd hh.mm.ss a',
          ['t']: 'hh.mm a',
          ['ts']: 'hh.mm.ss a',
        },      
      ['MM/dd/yy']: {
        ['d']: 'DD',
        ['dm']: 'MM/dd',
        ['dmy']: 'MM/dd/yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD HH:mm',
        ['dts']: 'DD HH:mm:ss',
        ['dmt']: 'MM/dd HH:mm',
        ['dmts']: 'MM/dd HH:mm:ss',
        ['dmyt']: 'MM/dd/yy HH:mm',
        ['dmyts']: 'MM/dd/yy HH:mm:ss',
        ['t']: 'HH:mm',
        ['ts']: 'HH:mm:ss',
      },
      ['MM-dd-yy']: {
        ['d']: 'DD',
        ['dm']: 'MM-dd',
        ['dmy']: 'MM-dd-yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD HH:mm',
        ['dts']: 'DD HH:mm:ss',
        ['dmt']: 'MM-dd HH:mm',
        ['dmts']: 'MM-dd HH:mm:ss',
        ['dmyt']: 'MM-dd-yy HH:mm',
        ['dmyts']: 'MM-dd-yy HH:mm:ss',
        ['t']: 'HH:mm',
        ['ts']: 'HH:mm:ss',
      }
    },
    ['hh:mm']: {
      ['dd MMM yyyy']: {
        ['d']: 'DD',
        ['dm']: 'dd MMM',
        ['dmy']: 'dd MMM yyyy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh:mm a',
        ['dts']: 'DD hh:mm:ss a',
        ['dmt']: 'dd MMM hh:mm a',
        ['dmts']: 'dd MMM hh:mm:ss a',
        ['dmyt']: 'dd MMM yyyy hh:mm a',
        ['dmyts']: 'dd MMM yyyy hh:mm:ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh:mm:ss a',
      },
      ['dd.MM.yy']: {
        ['d']: 'DD',
        ['dm']: 'dd.MM',
        ['dmy']: 'dd.MM.yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh:mm a',
        ['dts']: 'DD hh:mm:ss a',
        ['dmt']: 'dd.MM hh:mm a',
        ['dmts']: 'dd.MM hh:mm:ss a',
        ['dmyt']: 'dd.MM.yy hh:mm a',
        ['dmyts']: 'dd.MM.yy hh:mm:ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh:mm:ss a',
      },
      ['dd/MM/yy']: {
        ['d']: 'DD',
        ['dm']: 'dd/MM',
        ['dmy']: 'dd/MM/yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh:mm a',
        ['dts']: 'DD hh:mm:ss a',
        ['dmt']: 'dd/MM hh:mm a',
        ['dmts']: 'dd/MM hh:mm:ss a',
        ['dmyt']: 'dd/MM/yy hh:mm a',
        ['dmyts']: 'dd/MM/yy hh:mm:ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh:mm:ss a',
      },
      ['dd-MM-yy']: {
        ['d']: 'DD',
        ['dm']: 'dd-MM',
        ['dmy']: 'dd-MM-yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh:mm a',
        ['dts']: 'DD hh:mm:ss a',
        ['dmt']: 'dd-MM hh:mm a',
        ['dmts']: 'dd-MM hh:mm:ss a',
        ['dmyt']: 'dd-MM-yy hh:mm a',
        ['dmyts']: 'dd-MM-yy hh:mm:ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh:mm:ss a',
      },
      ['MMM dd yyyy']: {
        ['d']: 'DD',
        ['dm']: 'MMM dd',
        ['dmy']: 'MMM dd yyyy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh:mm a',
        ['dts']: 'DD hh:mm:ss a',
        ['dmt']: 'MMM dd hh:mm a',
        ['dmts']: 'MMM dd hh:mm:ss a',
        ['dmyt']: 'MMM dd yyyy hh:mm a',
        ['dmyts']: 'MMM dd yyyy hh:mm:ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh:mm:ss a',
      },
      ['MM.dd.yy']: {
        ['d']: 'DD',
        ['dm']: 'MM.dd',
        ['dmy']: 'MM.dd.yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh:mm a',
        ['dts']: 'DD hh:mm:ss a',
        ['dmt']: 'MM.dd hh:mm a',
        ['dmts']: 'MM.dd hh:mm:ss a',
        ['dmyt']: 'MM.dd.yy hh:mm a',
        ['dmyts']: 'MM.dd.yy hh:mm:ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh:mm:ss a',
      },
      ['yyyy.MM.dd']: {
          ['d']: 'DD',
          ['dm']: 'yyyy.MM',
          ['dmy']: 'yyyy.MM.dd',
          ['m']: 'MMM',
          ['my']: 'MMM yyyy',
          ['y']: 'yyyy',
          ['dt']: 'DD hh.mm a',
          ['dts']: 'DD hh.mm.ss a',
          ['dmt']: 'yyyy.MM hh.mm a',
          ['dmts']: 'yyyy.MM hh.mm.ss a',
          ['dmyt']: 'yyyy.MM.dd hh.mm a',
          ['dmyts']: 'yyyy.MM.dd hh.mm.ss a',
          ['t']: 'hh.mm a',
          ['ts']: 'hh.mm.ss a',
        },      
      ['MM/dd/yy']: {
        ['d']: 'DD',
        ['dm']: 'MM/dd',
        ['dmy']: 'MM/dd/yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh:mm a',
        ['dts']: 'DD hh:mm:ss a',
        ['dmt']: 'MM/dd hh:mm a',
        ['dmts']: 'MM/dd hh:mm:ss a',
        ['dmyt']: 'MM/dd/yy hh:mm a',
        ['dmyts']: 'MM/dd/yy hh:mm:ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh:mm:ss a',
      },
      ['MM-dd-yy']: {
        ['d']: 'DD',
        ['dm']: 'MM-dd',
        ['dmy']: 'MM-dd-yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh:mm a',
        ['dts']: 'DD hh:mm:ss a',
        ['dmt']: 'MM-dd hh:mm a',
        ['dmts']: 'MM-dd hh:mm:ss a',
        ['dmyt']: 'MM-dd-yy hh:mm a',
        ['dmyts']: 'MM-dd-yy hh:mm:ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh:mm:ss a',
      }
    },
    ['hh.mm']: {
      ['dd MMM yyyy']: {
        ['d']: 'DD',
        ['dm']: 'dd MMM',
        ['dmy']: 'dd MMM yyyy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh.mm a',
        ['dts']: 'DD hh.mm.ss a',
        ['dmt']: 'dd MMM hh.mm a',
        ['dmts']: 'dd MMM hh.mm.ss a',
        ['dmyt']: 'dd MMM yyyy hh.mm a',
        ['dmyts']: 'dd MMM yyyy hh.mm.ss a',
        ['t']: 'hh.mm a',
        ['ts']: 'hh.mm.ss a',
      },
      ['dd.MM.yy']: {
        ['d']: 'DD',
        ['dm']: 'dd.MM',
        ['dmy']: 'dd.MM.yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh.mm a',
        ['dts']: 'DD hh.mm.ss a',
        ['dmt']: 'dd.MM hh.mm a',
        ['dmts']: 'dd.MM hh.mm.ss a',
        ['dmyt']: 'dd.MM.yy hh.mm a',
        ['dmyts']: 'dd.MM.yy hh.mm.ss a',
        ['t']: 'hh.mm a',
        ['ts']: 'hh.mm.ss a',
      },
      ['dd/MM/yy']: {
        ['d']: 'DD',
        ['dm']: 'dd/MM',
        ['dmy']: 'dd/MM/yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh.mm a',
        ['dts']: 'DD hh.mm.ss a',
        ['dmt']: 'dd/MM hh.mm a',
        ['dmts']: 'dd/MM hh.mm.ss a',
        ['dmyt']: 'dd/MM/yy hh.mm a',
        ['dmyts']: 'dd/MM/yy hh.mm.ss a',
        ['t']: 'hh.mm a',
        ['ts']: 'hh.mm.ss a',
      },
      ['dd-MM-yy']: {
        ['d']: 'DD',
        ['dm']: 'dd-MM',
        ['dmy']: 'dd-MM-yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh.mm a',
        ['dts']: 'DD hh.mm.ss a',
        ['dmt']: 'dd-MM hh.mm a',
        ['dmts']: 'dd-MM hh.mm.ss a',
        ['dmyt']: 'dd-MM-yy hh.mm a',
        ['dmyts']: 'dd-MM-yy hh.mm.ss a',
        ['t']: 'hh:mm a',
        ['ts']: 'hh.mm.ss a',
      },
      ['MMM dd yyyy']: {
        ['d']: 'DD',
        ['dm']: 'MMM dd',
        ['dmy']: 'MMM dd yyyy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh.mm a',
        ['dts']: 'DD hh.mm.ss a',
        ['dmt']: 'MMM dd hh.mm a',
        ['dmts']: 'MMM dd hh.mm.ss a',
        ['dmyt']: 'MMM dd yyyy hh.mm a',
        ['dmyts']: 'MMM dd yyyy hh.mm.ss a',
        ['t']: 'hh.mm a',
        ['ts']: 'hh.mm.ss a',
      },
      ['MM.dd.yy']: {
        ['d']: 'DD',
        ['dm']: 'MM.dd',
        ['dmy']: 'MM.dd.yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh.mm a',
        ['dts']: 'DD hh.mm.ss a',
        ['dmt']: 'MM.dd hh.mm a',
        ['dmts']: 'MM.dd hh.mm.ss a',
        ['dmyt']: 'MM.dd.yy hh.mm a',
        ['dmyts']: 'MM.dd.yy hh.mm.ss a',
        ['t']: 'hh.mm a',
        ['ts']: 'hh.mm.ss a',
      },
      ['yyyy.MM.dd']: {
          ['d']: 'DD',
          ['dm']: 'yyyy.MM',
          ['dmy']: 'yyyy.MM.dd',
          ['m']: 'MMM',
          ['my']: 'MMM yyyy',
          ['y']: 'yyyy',
          ['dt']: 'DD hh.mm a',
          ['dts']: 'DD hh.mm.ss a',
          ['dmt']: 'yyyy.MM hh.mm a',
          ['dmts']: 'yyyy.MM hh.mm.ss a',
          ['dmyt']: 'yyyy.MM.dd hh.mm a',
          ['dmyts']: 'yyyy.MM.dd hh.mm.ss a',
          ['t']: 'hh.mm a',
          ['ts']: 'hh.mm.ss a',
        },      
      ['MM/dd/yy']: {
        ['d']: 'DD',
        ['dm']: 'MM/dd',
        ['dmy']: 'MM/dd/yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh.mm a',
        ['dts']: 'DD hh.mm.ss a',
        ['dmt']: 'MM/dd hh.mm a',
        ['dmts']: 'MM/dd hh.mm.ss a',
        ['dmyt']: 'MM/dd/yy hh.mm a',
        ['dmyts']: 'MM/dd/yy hh.mm.ss a',
        ['t']: 'hh.mm a',
        ['ts']: 'hh.mm.ss a',
      },
      ['MM-dd-yy']: {
        ['d']: 'DD',
        ['dm']: 'MM-dd',
        ['dmy']: 'MM-dd-yy',
        ['m']: 'MMM',
        ['my']: 'MMM yyyy',
        ['y']: 'yyyy',
        ['dt']: 'DD hh.mm a',
        ['dts']: 'DD hh.mm.ss a',
        ['dmt']: 'MM-dd hh.mm a',
        ['dmts']: 'MM-dd hh.mm.ss a',
        ['dmyt']: 'MM-dd-yy hh.mm a',
        ['dmyts']: 'MM-dd-yy hh.mm.ss a',
        ['t']: 'hh.mm a',
        ['ts']: 'hh.mm.ss a',
      }
    }
  };

  constructor(
    private userPreferencesService: UserPreferencesService,
  ) {
  }

  public getDateFormat(toShow: DateFormatT): string {
    const timeFormat = this.userPreferencesService?.timeFormat;
    const dateFormat = this.userPreferencesService?.dateFormat;
    return this.dateTimeFormats[timeFormat]?.[dateFormat]?.[toShow];
  }
}
